import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const Posts = () => {
  const [postsData, setPostsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getPosts = () => {
    axios.post(API_URL.POST_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          setPostsData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-right",
        });
      }
    );
  };

  const deletePosts = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.POST_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = postsData.filter((r) => r.id != row.id);
              setPostsData(newData);
            }
            toast.success(row.name + " Delete Successfully", {
              autoClose: 3000,
              position: "top-right",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  useEffect(() => {
    getPosts();
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <div className="d-flex align-items-center">
            <h5 className="me-1">Posts</h5>
            <small className="me-2">({postsData.length})</small>
          </div>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link
                  to={"/admin/posts/add"}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                  Posts
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "5%" }}>#</th>
                        <th style={{ width: "20%" }}>Photo / Video</th>
                        <th style={{ width: "65%" }}>Title</th>
                        <th style={{ width: "10%" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {postsData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            {row.image &&
                            <td className="table-avatar">
                              <div
                                style={{
                                  backgroundImage: "url(" + row.image + ")",
                                  backgroundSize: "cover",
                                  height: 80,
                                  width: 150,
                                }}
                              ></div>
                            </td>}
                            {row.video && <td className="table-avatar">
                              <video width="150" height="80" controls>
                                <source
                                  src={row.video}
                                  type="video/mp4"
                                />
                                Your browser does not support the video tag.
                              </video>
                            </td>}
                            <td>{row.title}</td>
                            <td className="d-flex justify-content-end gap-3">
                              <Link to={"/admin/posts/edit/" + row.id}>
                                <i className="fa fa-edit"></i>
                              </Link>
                              <i
                                onClick={() => deletePosts(row)}
                                className="fa fa-trash-alt"
                              ></i>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Posts;
